import * as React from 'react';

const SvgIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
    <path d="M380-380v-200h200v200zm60-60h80v-80h-80zm-70 290.77V-220h-77.69Q262-220 241-241t-21-51.31V-370h-70.77v-60H220v-100h-70.77v-60H220v-77.69Q220-698 241-719t51.31-21H370v-70.77h60V-740h100v-70.77h60V-740h77.69Q698-740 719-719t21 51.31V-590h70.77v60H740v100h70.77v60H740v77.69Q740-262 719-241t-51.31 21H590v70.77h-60V-220H430v70.77zM667.69-280q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-375.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H292.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v375.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85zM480-480"></path>
  </svg>
);

export default React.memo(SvgIcon);
